// ═══════════════════════════════════════════════════════════════════════════════
// Usage region — i18n key helpers for dropdown labels
// ═══════════════════════════════════════════════════════════════════════════════

import type { UsageRegion, UsageRegionGroup } from '@fdh/shared';

export const usageRegionLabelKey = (region: UsageRegion): string => `usageRegion.${region}`;

export const usageRegionGroupLabelKey = (group: UsageRegionGroup): string =>
  `usageRegion.group.${group}`;
